import { L } from './prefs';

export const ROLE: Record<string, [string, string]> = {
  owner: ['Owner', 'المالك'], admin: ['Admin', 'مسؤول'], finance: ['Finance', 'المالية'],
  supervisor: ['Supervisor', 'مشرف'], collector: ['Collector', 'محصّل'], auditor: ['Auditor', 'مدقق'],
};
export const PLAN: Record<string, [string, string]> = {
  free: ['Free', 'مجاني'], solo: ['Solo', 'فردي'], team: ['Team', 'الفريق'], business: ['Business', 'الأعمال'], enterprise: ['Enterprise', 'المؤسسات'],
};
export const roleName = (r: string) => { const x = ROLE[r]; return x ? L(x[0], x[1]) : r; };
export const planName = (p: string) => { const x = PLAN[p]; return x ? L(x[0], x[1]) : p; };
